import {
  EQuantityFormatKey,
  ETimeBaseUnit,
  ETimeAbbreviationStyle,
  ETimeFormatKey,
  IQuantityFormat,
  ITimeFormat
} from '../../StoreSettings.types';

export enum EAbbreviationDropdownType {
  SEPARATOR = 'separator',
  BOOLEAN = 'boolean'
}

export interface IAbbreviationOfferTab {
  key: EQuantityFormatKey;
  label: string;
}

export interface IAbbreviationToggleField {
  key: keyof IQuantityFormat;
  label: string;
}

export interface IAbbreviationDropdownField extends IAbbreviationToggleField {
  type: EAbbreviationDropdownType;
}

export interface IAbbreviationDropdownOption {
  value: string;
  label: string;
}

export type QuantityFieldPath = `${EQuantityFormatKey}.${keyof IQuantityFormat}`;

export type TimeFieldPath = `${ETimeFormatKey}.${keyof ITimeFormat}`;

export type SettingsFieldPath = QuantityFieldPath | TimeFieldPath;

export type QuantityFieldValue = string | number | boolean;

export type SettingsFieldValue =
  | QuantityFieldValue
  | ETimeBaseUnit
  | ETimeAbbreviationStyle;

export interface ITimeBaseUnitOption {
  value: ETimeBaseUnit;
  label: string;
}

export interface ITimeAbbreviationStyleOption {
  value: ETimeAbbreviationStyle;
  label: string;
  hint: string;
}
